import * as swcHelpers from '@swc/helpers';
import { useMutation, Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { LocaleUtils } from '@grandvisionhq/utils';
import { formatOptIns } from '../../Util/grouped-opt-ins.js';
import { CREATE_ACCOUNT } from '../operations/mutations/create-account.js';

// graphql endpoint wants iso format (yyyy-mm-dd)
const formatDateOfBirth = (inDate)=>{
    const [year, month, day] = inDate.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
const isFullPersonalDetails = (input)=>!!(input.firstName && input.lastName && input.phone && input.dateOfBirth)
;
const formatPersonalDetails = (input)=>({
        firstName: input.firstName,
        lastName: input.lastName,
        phone: input.phone,
        salutation: input.salutation,
        dateOfBirth: input.dateOfBirth && formatDateOfBirth(input.dateOfBirth)
    })
;
const useCreateAccount = ()=>{
    var ref;
    const [createAccount, { data , loading , error  }] = useMutation(CREATE_ACCOUNT);
    const { getLabel  } = useIntl();
    const locale = LocaleUtils.getLocaleFromCookie() || '';
    const callback = ({ email , availableOptIns , selectedOptIns , personalDetails , loginRedirectUrl  })=>createAccount({
            variables: {
                input: swcHelpers.objectSpread({
                    email
                }, personalDetails && isFullPersonalDetails(personalDetails) ? {
                    personalDetails: formatPersonalDetails(personalDetails)
                } : {}, {
                    optIns: formatOptIns(availableOptIns, selectedOptIns, getLabel),
                    reason: Types.AccountReason.SIGN_UP,
                    accountMetaData: {
                        accountOrigination: Types.AccountOrigination.ONLINE,
                        accountVerificationMethod: Types.AccountVerificationMethod.NONE
                    },
                    loginRedirectUrl
                }, locale ? {
                    locale
                } : null)
            }
        })
    ;
    return [
        callback,
        {
            customerId: (data === null || data === void 0 ? void 0 : (ref = data.createB2CCustomerAccount) === null || ref === void 0 ? void 0 : ref.customerId) || '',
            loading,
            error
        }, 
    ];
};

export { useCreateAccount };
//# sourceMappingURL=use-create-account.js.map
